import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import {
  NEW_TRANSCRIPT_EXPERIENCE_OWNER,
  NEW_TRANSCRIPT_EXPERIENCE_VIEWER,
} from 'constants/triggers';

import { useShouldShowTrigger } from 'hooks/triggers';
import { selectUserIsLogged } from 'selectors/user';

import {
  getNewTranscriptExperienceData,
  setNewTranscriptExperienceData,
} from '../../../utilities/localStorage';

const TranscriptNewExperienceWrapper = ({ children }) => {
  const isLoggedIn = useSelector(selectUserIsLogged);

  const [showNewExperience, setShowNewExperience] = useState(false);

  const showNewTranscriptExperienceOwner = useShouldShowTrigger(
    NEW_TRANSCRIPT_EXPERIENCE_OWNER
  );

  const showNewTranscriptExperienceViewer = useShouldShowTrigger(
    NEW_TRANSCRIPT_EXPERIENCE_VIEWER
  );

  const showNewTranscriptExperience =
    showNewTranscriptExperienceOwner && showNewTranscriptExperienceViewer;

  useEffect(() => {
    if (isLoggedIn && showNewTranscriptExperience) {
      setShowNewExperience(true);
    }

    if (!isLoggedIn) {
      const newExperienceData = getNewTranscriptExperienceData();

      // We need to check for undefined here in case the user browser does not
      // have localStorage support
      if (typeof newExperienceData === 'undefined' || newExperienceData?.show) {
        setShowNewExperience(true);
      }
      // key value pair does not exist in localStorage yet
      else if (!newExperienceData) {
        setNewTranscriptExperienceData({
          complete: false,
          show: true,
        });
        setShowNewExperience(true);
      }
      // trigger has been completed
      else if (newExperienceData?.complete) {
        setShowNewExperience(false);
      }
    }
  }, [showNewTranscriptExperience, setShowNewExperience, isLoggedIn]);

  return <>{children({ showNewExperience })}</>;
};

export default TranscriptNewExperienceWrapper;
